import { render } from "./AccountBoard.vue?vue&type=template&id=7c437a47"
import script from "./AccountBoard.vue?vue&type=script&lang=js"
export * from "./AccountBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__